var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.204,
    height: 6.847,
    viewBox: "0 0 9.204 6.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25621",
    "data-name": "Path 25621",
    d: "M175.589,265.417l-1.184-1.184-4.48,4.48-2.357-2.356-1.184,1.184,3.54,3.54h0Z",
    transform: "translate(-166.385 -264.233)",
    fill: "#3b792f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedGreen);
export default __webpack_public_path__ + "static/media/checked-green.130c8e77c484dcdd1cc6fa6fe63c1cc3.svg";
export { ForwardRef as ReactComponent };